
export class HoursofdayModel {
    name?:string;
    desciption?: string;
    from?: string;
    to?:string;
    type?:string;
    id?:number;
}
